import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const video = getSharedAsset('jigspace.mp4', 'demos', 'videos')
const poster = getSharedAsset('jigspace.png', 'demos', 'posters')
const monolith = getSharedAsset('jigspace.png', 'demos', 'monoliths')
const nextDemoThumbnail = getSharedAsset('vuzix.png', 'sessions', 'thumbnails')

export const jigspace: IDemo = {
  id: DemoIds.jigspace,
  type: E3DDemoNameVals.jigspace,
  video,
  poster,
  monolith,
  end: {
    header: 'Streamline prototyping using AR.',
    body:
      'By leveraging the power of the Verizon 5G Ultra Wideband network, JigSpace™, the next-gen augmented reality (AR) app, can help you prototype lean manufacturing processes, develop product demos and train teams—so you can visualize solutions faster.',
    nextDemoText: 'Augmented reality workforce solutions.',
    nextDemoThumbnail,
    nextDemoId: DemoIds.vuzix,
    previousDemoId: DemoIds.mecAndSmartVenues
  }
}
